/* eslint react/display-name:0 */
import React from 'react';

const SiteInfoContext = React.createContext({});

export const withSiteInfoContext = BaseComponent => props => (
    <SiteInfoContext.Consumer>
        {siteInfo => <BaseComponent siteInfo={siteInfo} {...props} />}
    </SiteInfoContext.Consumer>
);

export default SiteInfoContext;
